import useTranslate from 'hooks/useTranslate';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
	const { translate } = useTranslate();
	const navigate = useNavigate();

	const handleLoginRedirect = () => {
		navigate('/login');
	};

	return (
		<Container
			className="d-flex flex-column align-items-center justify-content-center"
			style={{ height: '100vh' }}
		>
			<Row className="text-center">
				<Col>
					<h1>{translate('Extras.unAuthorized')}</h1>
					<p>{translate('Extras.unAuthorizedContent')}</p>
					<Button variant="primary" onClick={() => handleLoginRedirect()}>
						{translate('Extras.goToLogin')}
					</Button>
				</Col>
			</Row>
		</Container>
	);
};

export default Unauthorized;
